import script from "./CVPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CVPage.vue?vue&type=script&setup=true&lang=js"

import "./CVPage.vue?vue&type=style&index=0&id=d9a1640e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9a1640e"]])

export default __exports__